export type CompanyEvaluationOption = {
  id: number;
  label: string;
  score: number;
};

export type CompanyEvaluationCriteria = {
  id: number;
  question: string;
  weight: number;
  options: CompanyEvaluationOption[];
};

export const EVALUATION_CRITERIA: CompanyEvaluationCriteria[] = [
  {
    id: 1,
    question: 'Tesis geçici mi kalıcı mı?',
    weight: 15,
    options: [
      { id: 1, label: 'KALICI', score: 15 },
      { id: 2, label: 'GEÇİCİ', score: 0 },
    ],
  },
  {
    id: 2,
    question: 'Karar vericiye erişim (ulaşabiliyor muyuz) var mı?',
    weight: 15,
    options: [
      { id: 3, label: 'EVET', score: 15 },
      { id: 4, label: 'HAYIR', score: 0 },
    ],
  },
  {
    id: 3,
    question: 'Samimiyet ve ilişki durumu nasıl?',
    weight: 20,
    options: [
      { id: 5, label: 'EVET', score: 20 },
      { id: 6, label: 'ORTA', score: 10 },
      { id: 7, label: 'HAYIR', score: 0 },
    ],
  },
  {
    id: 4,
    question: 'Kontrol tarihlerini kendi mi takip ediyor veya biz hatırlatınca hemen ilgileniyor ve dönüş yapıyor mu?',
    weight: 10,
    options: [
      { id: 8, label: 'EVET', score: 10 },
      { id: 9, label: 'HAYIR', score: 0 },
    ],
  },
  {
    id: 5,
    question: 'Kontrol ciddiyeti var mı? Kontrol işine önem veriyor mu?',
    weight: 10,
    options: [
      { id: 10, label: 'EVET', score: 10 },
      { id: 12, label: 'HAYIR', score: 0 },
      { id: 11, label: 'BİLMİYORUZ', score: 5 },
    ],
  },
  {
    id: 6,
    question: 'Son 2 yıldır kontrolleri kesintisiz olarak biz mi yapıyoruz?',
    weight: 15,
    options: [
      { id: 13, label: 'EVET', score: 15 },
      { id: 15, label: 'HAYIR', score: 0 },
      { id: 14, label: '2 YIL GEÇMEDİ', score: 7 },
    ],
  },
  {
    id: 7,
    question: 'Yoğun fiyat pazarlığı yapıyor mu?',
    weight: 10,
    options: [
      { id: 17, label: 'EVET', score: 0 },
      { id: 16, label: 'HAYIR', score: 10 },
    ],
  },
  {
    id: 8,
    question: 'Alternatif teklif topluyor mu?',
    weight: 5,
    options: [
      { id: 20, label: 'EVET', score: 0 },
      { id: 18, label: 'HAYIR', score: 5 },
      { id: 19, label: 'BİLMİYORUZ', score: 2 },
    ],
  },
];
